import React from "react";
import Testimonials from "../home/Testimonials";

const SalesTestimonials = () => {
  return <Testimonials />;
};

export default SalesTestimonials;
